import React, { useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Campersrent from "../../Components/Campersrent/Campersrent";
import { Link } from "react-router-dom";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/core';
import CamperAuthService from '../../Api/services/CamperAuthService';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
const Login = () => {
  const { i18n, t } = useTranslation();
  const [error, setError] = useState("")
  const navigate = useNavigate();
  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      if (event.target.email.value === '') {
        setError(t("Login.The email field is required."))
      }
      else if(event.target.password.value === '')
        {
          setError(t("Login.The password field is required."))
        }
      else {
        var userData = {
          "email": event.target.email.value,
          "password": event.target.password.value,
          "device_name": "web",
        }

        let responseData = await CamperAuthService.login(userData).json()
        console.log(responseData)
        if (responseData.status === true) {
          localStorage.setItem("user", JSON.stringify(responseData.user));
          localStorage.setItem("usertoken", JSON.stringify(responseData.idToken));
          navigate("/my_order");
        }
        setError(t("Login.The provided credentials are incorrect."))
      }
    } catch (error) {

      if (error.name === 'HTTPError') {

        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      } else {
        setError(t("Login.The provided credentials are incorrect."))
      }
    }

  };
  return (
    <>
      <Header />

      <div className="min-h-screen bg-off-white">
        <div className="pb-5 text-center">
          <div className="overflow-hidden">
            <div className="-ml-[5%] w-[110%] overflow-hidden rounded-b-[60%20%] px-[5%]">
              <div className="relative">
                <div className="overflow-hidden">
                  <img
                    src="/title-images/Login-page.jpg"
                    alt="trip-planner-banner"
                    className="absolute max-h-full w-full scale-110 object-cover blur-lg dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                  />
                </div>
                <picture className="flex max-h-[60vh] w-full text-0">
                  <img
                    className="z-0 max-h-full w-full object-cover dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                    src="/title-images/Login-page.jpg"
                    alt="trip-planner-banner"
                    width="2552"
                    height="1286"
                  />
                </picture>
                <div className="absolute top-0 left-0 flex h-full w-full flex-col items-center justify-end">
                  <div className="pb-12 w-full bg-gradient-to-t from-black-pure/80 to-transparent pt-20 md:pt-14 xl:pt-32">
                    <h1 className="whitespace-pre-line break-words m-auto max-w-4xl px-8 text-xl md:text-2xl text-white drop-shadow-text dark:text-off-white xs:text-2xl xl:text-3xl mb-5 md:mb-8 xl:mb-12">
                      {t("Login.Login")}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark relative mx-auto -mt-12 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
            <img className="" src="/Images/trip-planner-banner.svg" alt="trip-planner-banner" />
          </div>
        </div>

        <div className="mx-5 max-w-screen-xl xl-padded:mx-auto">

          <div className="pb-0 mx-auto flex max-w-3xl flex-col items-center text-center">
            <p className="mb-4 whitespace-pre-line text-md"> {t("Login.Booking Portal")}</p>
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl mb-4">{t("Login.Manage your booking in one place")}</h2>
            <p className="whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal login-heading-text">
              {t("Login.Have you already booked with us and want to access booking information, add additional accessories, expand your insurance package, or simply watch the instructional videos for your model?")}<br />{t("Login.Your password can be found in your confirmation email.")}<br />{t("Login.Use this password along with the email address you provided when making the booking to log in.")}</p>
          </div>
          <div className="pt-8 2xl:pt-12" id="">
            <div className="pt-8 2xl:pt-12 pb-8 2xl:pb-16">
              <div className="mx-auto flex max-w-3xl flex-col items-center bg-white rounded-button shadow rounded divide-secondary divide-opacity-disabled divide-y overflow-hidden sm:rounded-3xl -mt-10 pt-3 divide-y-0  md:py-10 md:px-10 px-5 py-5">
                <form className="flex w-full flex-col items-center" onSubmit={onSubmitForm}>
                  <div className="grid grid-cols-1 gap-x-4 md:grid-cols-2 w-full">

                    <div className="transition-all xl:mb-4 mb-0 col-span-2">
                      <div className="p-2 fw-500">{t("sale.Email")} *</div>
                      <div className="grey-border relative z-foreground xl:mb-4 mb-2 flex h-[60px] items-center rounded border bg-white text-black transition-all focus-within:border-primary focus:border-primary dark:bg-off-black-desat dark:text-off-white dark:focus-within:border-primary-dark border-transparent shadow dark:shadow-dark">
                        <div className="inline-block align-top absolute pl-3 child:h-7 child:w-7 dark:cssvar-secondary-to-off-white">
                          <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1"><title>icon_contact_mail</title><g id="icon_contact_mail" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Group" transform="translate(5.000000, 7.700000)" fill="var(--svg-color-secondary, #163435)"><path d="M17.1541722,0 C18.5243618,0 19.2165846,0.133674373 19.9368674,0.518885858 C20.6000248,0.873546296 21.1264537,1.39997522 21.4811141,2.06313259 C21.8663256,2.78341544 22,3.47563815 22,4.8458278 L21.9981828,11.9648343 C21.9810588,13.1622375 21.8406449,13.810058 21.4811141,14.482322 C21.1264537,15.1454793 20.6000248,15.6719082 19.9368674,16.0265687 C19.2165846,16.4117802 18.5243618,16.5454545 17.1541722,16.5454545 L4.8458278,16.5454545 C3.47563815,16.5454545 2.78341544,16.4117802 2.06313259,16.0265687 C1.39997522,15.6719082 0.873546296,15.1454793 0.518885858,14.482322 C0.133674373,13.7620391 0,13.0698164 0,11.6996267 L0,4.8458278 C0,3.47563815 0.133674373,2.78341544 0.518885858,2.06313259 C0.873546296,1.39997522 1.39997522,0.873546296 2.06313259,0.518885858 C2.78341544,0.133674373 3.47563815,0 4.8458278,0 Z M20,5.563 L11,12.1092247 L2,5.564 L2,11.6996267 L2.00467769,12.1173697 C2.02375106,12.8767631 2.10330814,13.2040417 2.28251225,13.5391242 C2.45077309,13.8537447 2.69170989,14.0946815 3.0063303,14.2629423 C3.31348932,14.4272127 3.61409085,14.507752 4.24698433,14.5347258 L4.6271902,14.5443078 L17.3728098,14.5443078 C17.4423488,14.5435357 17.5086323,14.5423663 17.5719151,14.5407769 L17.9176389,14.5260186 C18.4406182,14.4924165 18.7144342,14.4122791 18.9936697,14.2629423 C19.3082901,14.0946815 19.5492269,13.8537447 19.7174877,13.5391242 C19.9265592,13.1481946 20,12.767887 20,11.6996267 L20,5.563 Z M17.1541722,2 L4.8458278,2 L4.42808487,2.00467769 C3.66869148,2.02375106 3.34141286,2.10330814 3.0063303,2.28251225 C2.69170989,2.45077309 2.45077309,2.69170989 2.28251225,3.0063303 C2.24438729,3.07761778 2.21077244,3.14855205 2.1812906,3.22336911 L10.999,9.63500008 L19.8187094,3.22336911 C19.7892276,3.14855205 19.7556127,3.07761778 19.7174877,3.0063303 C19.5492269,2.69170989 19.3082901,2.45077309 18.9936697,2.28251225 C18.6585871,2.10330814 18.3313085,2.02375106 17.5719151,2.00467769 L17.1541722,2 Z" id="Combined-Shape"></path></g></g></svg>
                        </div>
                        <div className="peer flex w-full flex-col">
                          <input
                            className="peer w-full rounded bg-transparent pb-1 pl-12 text-md outline-none focus:pr-6 pr-6"
                            type="email" name="email"
                          />
                          <label
                            className="pointer-events-none absolute ml-12 origin-left translate-y-[15px] scale-100 cursor-text select-none text-md transition-all peer-focus-within:translate-y-1 peer-focus-within:scale-75 peer-focus-within:opacity-50"
                            htmlFor=""
                          >

                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="transition-all xl:mb-4 mb-0 col-span-2">
                      <div className="p-2 fw-500">{t("Login.Password")} *</div>
                      <div className="grey-border relative z-foreground mb-4 flex h-[60px] items-center rounded border bg-white text-black transition-all focus-within:border-primary focus:border-primary dark:bg-off-black-desat dark:text-off-white dark:focus-within:border-primary-dark border-transparent shadow dark:shadow-dark">
                        <div className="inline-block align-top absolute pl-3 child:h-7 child:w-7 dark:cssvar-secondary-to-off-white">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16 14.6527C13.6105 14.6527 11.6736 12.7158 11.6736 10.3264C11.6736 7.93688 13.6105 6 16 6C18.3895 6 20.3264 7.93688 20.3264 10.3264C20.3264 12.7158 18.3895 14.6527 16 14.6527Z"
                              fill="var(--svg-color-secondary, #163435)"
                            ></path>
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16.1565 15.9742C12.2188 15.8883 9 19.0545 9 22.9726C9 23.4621 9.05258 23.9383 9.15042 24.3979C9.26224 24.9247 9.72616 25.3021 10.2643 25.3021H21.7361C22.2693 25.3021 22.7352 24.9324 22.847 24.4112C23.0091 23.6528 23.05 22.8501 22.9329 22.0181C22.4596 18.6482 19.5587 16.0487 16.1565 15.9742Z"
                              fill="var(--svg-color-secondary, #163435)"
                            ></path>
                          </svg>
                        </div>
                        <div className="peer flex w-full flex-col">
                          <input
                            className="peer w-full rounded bg-transparent pb-1 pl-12 text-md outline-none focus:pr-6 pr-6"
                            type="password" name="password"
                          />
                          <label
                            className="pointer-events-none absolute ml-12 origin-left translate-y-[15px] scale-100 cursor-text select-none text-md transition-all peer-focus-within:translate-y-1 peer-focus-within:scale-75 peer-focus-within:opacity-50"
                            htmlFor=""
                          >

                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="mt-2 mb-4 col-span-2">
                      <div className="relative flex">
                        <input
                          type="checkbox"
                          className="peer h-7 w-7 min-w-[28px] cursor-pointer appearance-none rounded-sm border border-grey bg-white outline-none transition-all checked:border-primary checked:bg-primary focus:border-primary dark:border-grey-dark dark:bg-off-black-desat"
                          name=""
                          id=""
                          required
                        />
                        <div className="align-top pointer-events-none absolute left-0.5 top-0.5 hidden cssvar-secondary-to-white peer-checked:block child:h-6 child:w-6 dark:cssvar-secondary-to-off-white">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g fill="none" fillRule="evenodd">
                              <path
                                d="m21.906 9.488-8.547 9.56-3.45-3.096a1.757 1.757 0 0 0-2.563.209c-.64.792-.547 1.98.21 2.659l4.764 4.274c.735.66 1.833.602 2.496-.13l9.73-10.869a1.954 1.954 0 0 0-.069-2.665 1.758 1.758 0 0 0-2.571.058z"
                                fill="var(--svg-color-secondary, #163435)"
                              ></path>
                            </g>
                          </svg>
                        </div>
                        <label className="ml-3 cursor-pointer" htmlFor="">
                          {
                            i18n.resolvedLanguage === 'en' ?
                              <>
                                <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                                  I have read the &nbsp;
                                  <Link
                                    to={"/privacystatement"}
                                    className="inline-block text-primary underline hover:text-off-black dark:text-primary-light hover:dark:text-off-white"
                                  >
                                    data {t("sale.privacy")}&nbsp;{t("sale.statement")}
                                  </Link>

                                </div>
                              </>
                              :
                              <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                                {t("sale.I have read the")}{" "}
                                <Link
                                  to={"/privacystatement"}
                                  className="inline-block text-primary underline hover:text-off-black dark:text-primary-light hover:dark:text-off-white"
                                >
                                  {t("sale.privacy")}
                                </Link>
                                &nbsp;{t("sale.statement")}
                              </div>
                          }
                        </label>
                      </div>
                      <div className="relative bottom-4 overflow-hidden bg-warning text-center text-xs font-medium text-black transition-all mt-1 rounded max-h-0"></div>
                    </div>

                  </div>
                  <div className="text-danger fs-12" >    {error ? <p style={{ color: "red" }} className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white">{error}</p> : ''}</div>
                  <button
                    type="submit"
                    className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated pr-5 mt-2 w-full md:w-auto md:min-w-[50%]"
                  >
                    <div className="flex h-full items-center justify-center">
                      <span className="flex">{t("Login.Login1")}</span>
                    </div>
                  </button>

                  {/* <button
                    onClick={() => navigate("/registration")}
                    className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated pr-5 mt-2 w-full md:w-auto md:min-w-[50%]"
                  >
                    <div className="flex h-full items-center justify-center">
                      <span className="flex">Registration</span>
                    </div>
                  </button> */}
                  <p className="mt-5 text-xs">{t("sale.*Mandatory field")}</p>
                </form>

              </div>
            </div>
          </div>

        </div>

      </div>

      <Footer />
    </>
  );
};

export default Login;

